import React from 'react'

export default function NotFoundPage(params) {
    return(<div>
        <div style={{textAlign:"center",fontSize:"30px", marginTop:"20px"}}>
        <span>¯\_(ツ)_/¯</span> 
        </div>

    </div>)
}